import { render, staticRenderFns } from "./lrNum.vue?vue&type=template&id=3d9a9f48&scoped=true&"
import script from "./lrNum.vue?vue&type=script&lang=js&"
export * from "./lrNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9a9f48",
  null
  
)

export default component.exports